import 'core-js/proposals/set-methods-v2';
import { KeywordSet } from '@rsos/reduxDataStore/src/features/keywords';
import {
  trackSuggestedKeywordEvent,
  trackManualKeywordEvent,
  trackRemovedKeywordEvent,
  trackChangeKeywordEvent,
} from './KeywordAdminEvents';

/**
 * We want to track adding and removing of harmony-suggested keywords separately
 * from manually added keywords, but only at save-time. This class tracks which
 * keywords came from where in a given editing session.
 */
export class KeywordChangeTracker {
  public keywordSet: KeywordSet;

  existingWordCountsForSuggestedKeywords: { [word: string]: number };
  constructor(keywordSet: KeywordSet) {
    this.keywordSet = { ...keywordSet, keywords: [...keywordSet.keywords] };
    this.existingWordCountsForSuggestedKeywords = {};
  }

  addSuggestion(suggestion: string, currentCount: number) {
    this.existingWordCountsForSuggestedKeywords[suggestion] = currentCount;
  }

  fireEvents(finalKeywordSet: KeywordSet) {
    const initial = new Set(this.keywordSet.keywords);
    const final = new Set(finalKeywordSet.keywords);
    const addedSuggestions = new Set(
      Object.keys(this.existingWordCountsForSuggestedKeywords),
    );
    const suggested = addedSuggestions.intersection(final);
    const manual = final.difference(initial).difference(addedSuggestions);
    const removed = initial.difference(final);
    suggested.forEach(word => {
      trackSuggestedKeywordEvent(
        finalKeywordSet,
        word,
        this.existingWordCountsForSuggestedKeywords[word],
      );
    });
    manual.forEach(word => {
      trackManualKeywordEvent(finalKeywordSet, word);
    });
    removed.forEach(word => {
      trackRemovedKeywordEvent(finalKeywordSet, word);
    });

    (Object.keys(this.keywordSet) as [keyof KeywordSet]).forEach(
      (key: keyof KeywordSet) => {
        if (key === 'keywords') return;
        if (finalKeywordSet[key] != this.keywordSet[key]) {
          trackChangeKeywordEvent(
            finalKeywordSet,
            key,
            this.keywordSet[key],
            finalKeywordSet[key],
          );
        }
      },
    );
  }
}

// These methods are available in modern browsers, and via core-js for older
// browsers, but aren't typed. Feel free to remove this when the time comes that
// it is unnecessary.
declare global {
  interface Set<T> {
    intersection(other: Set<T>): Set<T>;
  }
}
